import * as api from '../api.service';
import { DrugLookupResponseDto } from '../../interfaces/DrugLookupResponseDto';

const getDrugLookupDtoOnNdcCode = async (ndcCode: any) => {
  const response = await api.fetchData<DrugLookupResponseDto>(`${process.env.REACT_APP_API_URL}/drugdetails/ndccode/${ndcCode}`);
  return response;
};

const getDrugLookupDtoOnDrugName = async (drugName: any) => {
  const response = await api.fetchData<DrugLookupResponseDto>(`${process.env.REACT_APP_API_URL}/drugdetails/drugname/${drugName}`);
  return response;
};

const DrugLookupService = {
  getDrugLookupDtoOnNdcCode,
  getDrugLookupDtoOnDrugName,
};

export default DrugLookupService;
